import { Button, Typography } from "@material-ui/core";
import React, { useState } from "react";
import { withRouter } from "react-router-dom";
import TitleContainer from "~/components/common/titleContainer/TitleContainer";
import useStyles from "./styles";
import { useTranslation } from "react-i18next";
import GoogleIcon from '@mui/icons-material/Google';
import PhoneIcon from '@material-ui/icons/Phone';
import { getAuth, GoogleAuthProvider, signInWithPopup } from "firebase/auth";
import { useSelector } from "react-redux";
import checkoutServices from "~/services/checkoutServices";

function OptionsLoginComponent(props) { 
	const classes = useStyles();

	const { t } = useTranslation();
	const [loading, setLoading] = useState(false);
	const { business } = useSelector((store) => store.business);


	const { goBackRoute, goBackRouteProps } = props.location.state;

	const onClickGoBack = () => {
		props.history.goBack();
	};
	
    const provider = new GoogleAuthProvider();
	const auth = getAuth();

    const login = async () => {
		try {
		  await signInWithPopup(auth, provider);
		  
		  const res = await checkoutServices.me();
	  
		  if (res?.data?.id) {
			localStorage.setItem("@prit-web/meData", JSON.stringify(res.data));
			localStorage.setItem("@prit-web/userId", res.data.id);
		  }

          if (!res.data.phoneUnverified) {
			props.history.replace("/login/personal-information-number", {
				logEventFor: "Google",
				goBackRoute: goBackRoute,
				goBackRouteProps: props.location.state,
			});
		} else {
			props.history.push(goBackRoute);
		}

		  props.history.push(goBackRoute)
		} catch (error) {
		  alert(`Erro durante o login com Google: ${error.message}`);
		}
	};

    const handleScheduleReservationsClick = () => {
			localStorage.setItem("goBackRoute", JSON.stringify(goBackRoute));
			props.history.push(`/login`, {
				goBackRoute,
				goBackRouteProps
			});
	};

	return (
		<>
			<TitleContainer
				loading={loading}
				handleClick={onClickGoBack}
				headerStyle={{ boxShadow: "none", paddingBottom: "0" }}
				//footer={footer(submitForm)}
			>
                <Typography className={classes.message} style={{ color: "#333", textAlign:"-webkit-center",fontSize: 16 }}>
                    <strong>{t("To access this page, please Login")}</strong>
                </Typography>
				
                <div style={{ width: "100%", justifyContent: "center", display: "grid" }}>
					{ process.env.REACT_APP_GOOGLE_LOGIN_ENABLED === "true" && 
						<Button
							disabled={false}
							className={classes.root}
							style={{
							textTransform: "uppercase",
							fontWeight: "Bold",
							marginBottom: "5%",
							}}
							onClick={() => {login()}}
						>
							<GoogleIcon style={{ position: 'absolute', left: 16 }} />
							<span style={{ flexGrow: 1, textAlign: 'center' }}>{t("Continue Google")}</span>
						</Button>
					}
					<Button
						disabled={false}
						onClick={() => {handleScheduleReservationsClick()}}
						className={classes.root}
						style={{
							textTransform: "uppercase",
							fontWeight: "Bold",
							backgroundColor: '#fff',
							border: "2px solid #440067",
							color: "#440067"
						}}>								
						{ <PhoneIcon style={{ position: 'absolute', left: 16 }} /> }
						{t("Continue")}
					</Button>
				</div>
			</TitleContainer>
			{/* <WhatsAppButton bottom={"30px"} /> */}
		</>
	);
}

export default withRouter(OptionsLoginComponent);
